@if (showTitle) {
  <div #appTittle class="title-view" [ngClass]="{'innerHeader': innerHeader, 'whiteBg': back }">
    <div class="title-name">
      @if (back) {
        <i class="icon-back backIcon" id="icon-back" (click)="backClick($event)"></i>
      }
      <h1 class="pageHeaderClass title-class" [ngClass]="{'no-pad':back}" >{{pageTitle}}@if (messageCount && messageCount > 0) {
        <span>({{messageCount}})</span>
      }</h1>
    </div>
    <div class="title-icon">      
      @if (voiceAssistantActionShow) {
        <div class="voiceAssistantIconWrap" [ngClass]="voiceAssistantActionDisabled ? 'disableIcon' : ''">
          <i class="icon-AI-Icon voiceAssistantIcon" id="voiceAssistant" (click)="voiceAssistantActionClick($event)"></i>
        </div>
      }
      @if (sync) {
        <i class="icon-sync-all requisitionIcon" [ngClass]="{'disableIcon':options.disableSync}" (click)="syncClick($event)"></i>
      }
      @if (requisition) {
        <i class="icon-load1 requisitionIcon" id="loadmessage" [ngClass]="{'disableIcon':options.disablerequisition}" (click)="loadRequisitionClick($event)"></i>
      }
      @if (poRequisition) {
        <i class="icon-load1 requisitionIcon" [ngbTooltip]="loadReqToolTip" triggers="click:blur" tooltipClass='title-tooltip' placement="bottom-right"></i>
      }
      @if (isReconcile) {
        <i class="icon-In_transit_Truck reconcileIcon" triggers="click:blur" tooltipClass='title-tooltip' placement="bottom-right" (click)="Reconcile($event)"></i>
      }
      <ng-template #loadReqToolTip  >
        <div class="loadReqToolTipWrap">
          <!-- <div class="tooltipData" (click)="loadReqClick($event)">{{poReqTooltipText.LoadReq}}</div>  -->
          @for (tooltipText of poReqTooltipText; track tooltipText; let i = $index) {
            <div class="tooltipData"  (click)="loadReqClick($event, tooltipText.id)">{{tooltipText.name}}</div>
          }
        </div>
      </ng-template>
      @if (mail) {
        <i class="icon-send-mail actionIcon" id="sendMail" [ngClass]="{'disableIcon':options.disableAction}" (click)="sendMailClick($event)"></i>
      }
      @if (action) {
        <i class="icon-add actionIcon" id="addIcon" [ngClass]="{'disableIcon':options.disableAction}" (click)="actionClick($event)"></i>
      }
      @if (edit) {
        <i class="icon-edit1 editIcon" id="editIcon" (click)="editClick($event)" [ngClass]="disableEdit ? 'disable':''"></i>
      }
      @if (delete) {
        <i class="actionIcon icon-delete" id="deleteIcon" (click)="deleteClick($event)"></i>
      }
      @if (more) {
        <i class="icon-more moreIcon" [matMenuTriggerFor]="moremenu"></i>
      }
      <mat-menu #moremenu="matMenu" id="titlemoreOption">
        @for (option of moreOptions; track option) {
          <button mat-menu-item (click)='moreOptionsClicked(data,option.id)'>
            <i [class]='option.icon'></i>
            <span class="text-capitalize">{{option.name}}</span>
          </button>
        }
      </mat-menu>
      <button mat-button class="button-text action-button-desktop" >{{buttonText}}</button>
    </div>
  </div>
}

